import { CartItem } from "../interfaces/cart-item";
import { CALCOLO_PREZZO, ESPLOSIONE, MOD_CALCOLO_PREZZO } from "../interfaces/custom/articolo";


function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}


///La funzione crea un array di oggetti che rappresentano le righe di un documento in caso nel documento sia presente un articolo di tipo Box Semplice o Box Componibile
export function createCorpoForBox(item : CartItem, rowArticle, tipo_prezzo, idx) {
    let cartItem = item;
    let articolo = item.product;

    let rows = [];

    rowArticle['tipoRiga'] = 0;
    if (articolo.flg_esplosione == ESPLOSIONE.PADRE) {
        rowArticle['tipoRiga'] = 2;
        rowArticle['descrizioneArticolo'] = item.product.descart;
    }
    rowArticle['riferimentoInternoDocumento'] = idx + '-ART';
    rows.push(rowArticle);

    let general_price = item.price;

    // Calcola la percentuale generale (potrebbe essere diversa da 100)
    let general_percent = 0;
    for (let level of item.box_levels) {
        general_percent += level.percentuale_ripartizione;
    }

    for (let level of item.box_levels) {
        //Si calcola la percentuale per il singolo livello che si sta considerando
        let percentForLevel = level.percentuale_ripartizione * 100 / general_percent;
        //Calcolo quanto del prezzo ufficiale del box deve essere destinato al livello che si sta considerando
        let priceForLevel = percentForLevel / 100 * general_price;
        let generalLevelPercent = 0;
        let generalLevelPrice = 0;
        //Ciclo per gli articoli presenti a livello
        for (let item of level.items) {
            generalLevelPercent += item.percentuale * item.qta_selezionata;
            let itemPrice = tipo_prezzo == 'b2b' ? item.prezzo_netto : item.prezzo_lordo;
            generalLevelPrice += itemPrice * item.qta_selezionata;
        }
        // GeneralLevelPrice contiene il prezzo totale di tutti gli articoli presenti a livello
        // GeneralLevelPercent contiene la percentuale di tutti gli articoli presenti a livello
        // Ora calcolo se devo scontare o maggiorare gli articoli a livello (per far tornare i conti a livello microscopico)
        // Se generalLevelPrice > priceForLevel => sconto, invece maggiorazione;
        let scontoMaggiorazioneLevel = generalLevelPrice - priceForLevel;

        for (let item of level.items) {
            let subRow = {};
            subRow['codiceArticolo'] = item.codice_articolo_componente;
            subRow['qta'] = item.qta_selezionata * cartItem.quantity;
            subRow['tipoRiga'] = 2;
            subRow['descrizioneArticolo'] = item.articolo_componente.descart;
            // Se l'esplosione è sul padre, devo inserire il padre come descrittivo e tutte le righe figlie come puntuali quindi 
            // imposto la riga su tipoRiga = 0 -> Articolo
            if (articolo.flg_esplosione == ESPLOSIONE.PADRE) {
                subRow['tipoRiga'] = 0;
            }

            let itemPrice = tipo_prezzo == 'b2b' ? item.prezzo_netto : item.prezzo_lordo;

            subRow['prezzo'] = itemPrice;

            if (articolo.calcolo_prezzo != CALCOLO_PREZZO.PUNTUALE) {
                //Se il calcolo del prezzo non è a composizione, allora devo calcolare il prezzo in base alla percentuale
                if (articolo.mod_calcolo_prezzo == MOD_CALCOLO_PREZZO.PERCENTUALE) {
                    // Calcolo la percentuale su questo livello e ripartisco il prezzo del livello
                    let normalizedPercent = item.percentuale * 100 / generalLevelPercent;
                    subRow['prezzo'] = normalizedPercent / 100 * priceForLevel;
                }
                else {
                    // Devo aggiungere delle righe si sconto 
                    if (scontoMaggiorazioneLevel != 0) {
                        let tipo = scontoMaggiorazioneLevel > 0 ? 0 : 1;
                        let valore = scontoMaggiorazioneLevel < 0 ? scontoMaggiorazioneLevel * -1 : scontoMaggiorazioneLevel;
                        if (!generalLevelPrice)
                            valore = 0;
                        else
                            valore = itemPrice / generalLevelPrice * valore;

                        subRow["sconti_maggiorazioni"] = [
                            {
                                "tipo_sconto": tipo,
                                "ind_per_ass": 1,
                                "valore": valore,
                                "provenienza": null
                            }
                        ];
                    }
                }
            }

            subRow['riferimentoInternoDocumento'] = idx + '-COMP';
            rows.push(subRow);
        }
    }

    if (item.attributi) {
        let attributeRows = attributiMakeRows(item, rowArticle, idx);
        rows = rows.concat(attributeRows);
    }

    return rows;
}

export function attributiMakeRows(item : CartItem, rowArticle, idx) {
    let rows = [];

    for (let attribute of item.attributi) {
        let row = {};
        row['tipoRiga'] = attribute.tipo_battuta;
        row['riferimentoInternoDocumento'] = idx + '-ATTR';
        row['qta'] = item.quantity;
        row['descrizioneArticolo'] = attribute.descrizione;
        if (attribute.tipo_battuta == 0)
            row['codiceArticolo'] = attribute.articolo_collegato;
        if (attribute.tipo_battuta == 1) {
            row['iva'] = item.product.aliquota;
        }
        row['prezzo'] = attribute.prezzo;
        rows.push(row);
    }

    return rows;
}